import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  SectionTitle,
  Header,
  Intro,
} from '../../../../components'
import data from './data.json'
import './style.scss'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Tooltips are elevated labels that provide brief, supplementary
            information about the element they point to. They are
            keyboard-navigation friendly and triggered on click, tap or keyboard
            focus. Tooltips do not support rich text or complex operations.
          </p>
          <p>
            Tooltips hide information by default, therefore they should be used
            sparingly. If the user needs to know the information within the
            tooltip to complete their task, place it within the main layout.
            Additionally, tooltip content should be unique and not repeat
            information that already exists on the page.
          </p>
        </Intro>
        <SectionTitle>Usage</SectionTitle>

        <Showcase
          title="Tooltip"
          text="The default tooltip is an accessible element that is expressly user-dismissed with the available 'Close' function. A tooltip may optionally include a title for easier readability and to create hierarchy."
        >
          <div class="c-tooltip c-tooltip--top">
            <div class="c-tooltip__header">
              <h1 class="c-tooltip__title">Title</h1>
              <button class="c-tooltip__close-button">
                Close <i class="c-tooltip__close-button-icon icon icon--x"></i>
              </button>
            </div>
            <div class="c-tooltip__content">
              I provide additional information that is nice to have but that you
              don't need to complete your task.
            </div>
          </div>
        </Showcase>

        <hr />

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Offer consistent visual cues indicating a tooltip is present, either
          as standalone elements (e.g. Help Links) or as a specific treatment
          for inline elements (e.g. dotted underline on inline text). Tooltip
          positioning within the layout is programatically determined by the
          caret's placement in relation to the element it points to. This
          ensures that the tooltip stays in the context of the appropriate page
          item across breakpoints. In order to avoid a tooltip covering related
          content, they include a padding of 8 px between the tooltip caret and
          the element it points to.
        </p>
        <p>
          The information within a tooltip will not scroll, so be careful not to
          overload your tooltip with content. If there is a need for additional
          context, consider using a{' '}
          <Link
            to={'/' + data.site + '/patterns/modal/design'}
            className="link"
          >
            modal
          </Link>{' '}
          instead.
        </p>
        <p>
          Tooltips are elevated to the interaction level of the{' '}
          <Link
            to={'/' + data.site + '/guidelines/elevation/design'}
            className="link"
          >
            elevation structure
          </Link>{' '}
          and have a small{' '}
          <Link
            to={'/' + data.site + '/utilities/shadow/design'}
            className="link"
          >
            shadow
          </Link>
          .
        </p>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Tooltip content may be fragments or full sentences but should be as
          concise as possible. Fragments and full sentences should both use
          sentence case, but only full sentences should include end punctuation
          unless the fragment is a question. If including a title, follow the
          microcopy guidelines of the{' '}
          <Link
            to={'/' + data.site + '/components/title/design/'}
            className="link"
          >
            title
          </Link>{' '}
          component. The information in a tooltip should be as concise as
          possible and should not be necessary for the user to complete a task.
          Additionally, tooltips should be unique and not repeat information
          that is on the page.
        </p>
      </Layout>
    </>
  )
}
